// @ts-nocheck
(function() {
  'use strict';
  
  const MobileBurgerMenu = {
    elements: {
      burger: null,
      navSm: null,
      body: document.body
    },

    config: {
      mobileBreakpoint: 1299
    },

    init() {
      this.elements.burger = document.getElementById('burger-button-on-header');
      this.elements.navSm = document.querySelector('.nav-sm');
      if (!this.elements.burger || !this.elements.navSm) return;
      this.bindEvents();
    },

    isMobile() {
      return window.innerWidth <= this.config.mobileBreakpoint;
    },

    bindEvents() {
      this.elements.burger.addEventListener('click', this.handleBurgerClick.bind(this));
      document.addEventListener('click', this.handleOutsideClick.bind(this));
      window.addEventListener('resize', this.handleResize.bind(this));
    },

    handleBurgerClick(e) {
      e.preventDefault();
      if (!this.isMobile()) return;

      this.elements.burger.classList.contains('open')
        ? this.closeMobileMenu()
        : this.openMobileMenu();
    },

    handleOutsideClick(e) {
      if (!this.isMobile()) return;

      const isClickInsideNav = this.elements.navSm.contains(e.target);
      const isClickOnBurger = this.elements.burger.contains(e.target);

      if (!isClickInsideNav && !isClickOnBurger && this.elements.burger.classList.contains('open')) {
        this.closeMobileMenu();
      }
    },

    handleResize() {
      if (!this.isMobile() && this.elements.burger.classList.contains('open')) {
        this.closeMobileMenu();
      }
    },

    openMobileMenu() {
      var headerGroup = document.getElementById('header-group');
      if (headerGroup) {
        this.elements.navSm.style.top = headerGroup.getBoundingClientRect().bottom + 'px';
      }
      this.elements.burger.classList.add('open');
      this.elements.body.style.overflow = 'hidden';
      this.elements.navSm.style.overscrollBehavior = 'contain';
    },

    closeMobileMenu() {
      this.elements.burger.classList.remove('open');
      this.elements.body.style.overflow = '';
      this.elements.navSm.style.overscrollBehavior = '';
    }
  };

  const SearchToggle = {
    scrollY: 0,

    init() {
      this.captureScrollOnClick();
      this.observeModal();
    },

    captureScrollOnClick() {
      document.querySelectorAll('[data-search-trigger]').forEach(el => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          this.scrollY = window.scrollY;

          // Open Rebuy Smart Search quickview
          function tryOpenRebuySearch() {
            var dropdown = document.querySelector('.rebuy-quick-view-dropdown');
            if (!dropdown) return false;

            var vueEl = dropdown;
            while (vueEl && !vueEl.__vue__) vueEl = vueEl.parentElement;

            if (vueEl && vueEl.__vue__) {
              var vm = vueEl.__vue__;
              if (!vm.isQuickViewOpen) {
                vm.openQuickView();
              } else {
                vm.closeQuickView();
              }
              return true;
            }

            return false;
          }

          if (!tryOpenRebuySearch()) {
            var attempts = 0;
            var retryInterval = setInterval(function() {
              attempts++;
              if (tryOpenRebuySearch() || attempts > 15) {
                clearInterval(retryInterval);
                if (attempts > 15) window.location.href = '/search';
              }
            }, 300);
          }
        });
      });
    },

    isModalVisible(el) {
      if (!el) return false;
      const style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
    },

    isRebuyCartOpen() {
      var cart = document.getElementById('rebuy-cart');
      if (!cart) return false;
      return cart.classList.contains('is-visible');
    },

    observeModal() {
      const checkModal = () => {
        // Don't touch overflow when Rebuy Smart Cart is open
        if (this.isRebuyCartOpen()) return;

        // Check for Rebuy Smart Search modal
        const modal = document.querySelector('[data-rebuy-smartsearch-modal]')
          || document.querySelector('.rebuy-smartsearch-modal');

        if (this.isModalVisible(modal)) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      };

      const observer = new MutationObserver(checkModal);
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }
  };

  const ProductSwiperManager = {
    initialized: new Set(), 

    init() {
      this.initializeAllSwipers();
      this.observeProductGrid();
      
      window.addEventListener('load', () => {
        setTimeout(() => this.initializeAllSwipers(), 500);
      });
    },

    observeProductGrid() {
      const observer = new MutationObserver((mutations) => {
        let shouldReinit = false;
        
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { 
              if (node.classList?.contains('product-grid__item') || 
                  node.querySelector?.('[class*="swiper-"]')) {
                shouldReinit = true;
              }
            }
          });
        });
        
        if (shouldReinit) {
          setTimeout(() => this.initializeAllSwipers(), 100);
        }
      });

      const targetNode = document.querySelector('#MainContent, main, body');
      if (targetNode) {
        observer.observe(targetNode, {
          childList: true,
          subtree: true
        });
      }
    },

    initializeAllSwipers() {
      if (typeof Swiper === 'undefined') {
        setTimeout(() => this.initializeAllSwipers(), 200);
        return;
      }

      this.initializeProductCardSwipers();
      this.initializeDetailCardSwipers();
    },

    initializeProductCardSwipers() {
      const swiperElements = document.querySelectorAll('[class*="product-image-swiper-"]');
      
      swiperElements.forEach((swiperEl) => {
        const classList = Array.from(swiperEl.classList);
        const swiperClass = classList.find(cls => cls.startsWith('product-image-swiper-'));
        const productId = swiperClass ? swiperClass.replace('product-image-swiper-', '') : '';
        
        if (!productId) return;
        
        const uniqueKey = `product-${productId}`;
        
        if (swiperEl.swiper || this.initialized.has(uniqueKey)) return;
        
        try {
          new Swiper(swiperEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            pagination: {
              el: `.product-image-swiper-pagination-${productId}`,
              clickable: true,
              bulletClass: 'swiper-pagination-bullet',
              bulletActiveClass: 'swiper-pagination-bullet-active',
            },
            lazy: {
              loadPrevNext: true,
            },
            observer: true,
            observeParents: true,
            speed: 300,
          });
          
          this.initialized.add(uniqueKey);
        } catch (error) {
          // console.error('Error initializing product swiper:', productId, error);
        }
      });
    },

    initializeDetailCardSwipers() {
      const detailSwiperElements = document.querySelectorAll('[class*="detail-card-swiper-"]');
      
      detailSwiperElements.forEach((swiperEl) => {
        const classList = Array.from(swiperEl.classList);
        const swiperClass = classList.find(cls => cls.startsWith('detail-card-swiper-'));
        const productId = swiperClass ? swiperClass.replace('detail-card-swiper-', '') : '';
        
        if (!productId) return;
        
        const uniqueKey = `detail-${productId}`;
        
        if (swiperEl.swiper || this.initialized.has(uniqueKey)) return;
        
        try {
          new Swiper(swiperEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            pagination: {
              el: `.detail-card-swiper-pagination-${productId}`,
              clickable: true,
              bulletClass: 'swiper-pagination-bullet',
              bulletActiveClass: 'swiper-pagination-bullet-active',
            },
            lazy: {
              loadPrevNext: true,
            },
            observer: true,
            observeParents: true,
            speed: 300,
          });
          
          this.initialized.add(uniqueKey);
        } catch (error) {
          // console.error('Error initializing detail card swiper:', productId, error);
        }
      });
    },
    reinitialize() {
      this.initializeAllSwipers();
    }
  };

  window.ProductSwiperManager = ProductSwiperManager;

  // Attentive form submit
  const AttentiveForm = {
    init() {
      const attentiveForms = document.querySelectorAll("#attentiveForm");
      const attentiveInputs = document.querySelectorAll(".footer__email-submit-wrap input");
      
      if (attentiveInputs.length > 0) {
        attentiveInputs.forEach((input) => {
          input.addEventListener("click", (e) => {
            e.preventDefault();
            input.parentElement.classList.add("active");
            const html = document.querySelector("html");
            html.addEventListener("click", function (e) {
              if (e.target !== input && !input.value)
                input.parentElement.classList.remove("active");
            });
          });
        });
      }
      
      if (attentiveForms) {
        attentiveForms.forEach((form) => {
          const zapierPath = form.dataset.zapierPath;
          const zapierID = form.dataset.zapierId;
          form.addEventListener("submit", (e) => {
            e.preventDefault();
            const formData = new FormData(form);
            fetch(
              "https://hooks.zapier.com/hooks/catch/" +
                zapierPath +
                "/" +
                zapierID +
                "/",
              {
                method: "post",
                body: formData,
              }
            )
              .then((response) => response.json())
              .then((text) => {
                form.classList.add("form-submitted");
                const successMsg = form.querySelector(".form-success");
                if (successMsg) successMsg.classList.remove("hidden");
              })
              .catch((error) => console.error(error));
          });
        });
      }
    }
  };
  
  const MiniCartTrigger = {
    savedScrollY: 0,

    init() {
      this.bindCartTrigger();
      this.bindScrollPreservation();
    },

    bindCartTrigger() {
      document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-mini-cart-trigger]');
        if (!trigger) return;

        e.preventDefault();

        if (typeof Rebuy !== 'undefined' && Rebuy.SmartCart) {
          Rebuy.SmartCart.show();
        } else {
          // Rebuy not loaded yet — wait then open
          document.addEventListener('rebuy.ready', () => {
            Rebuy.SmartCart.show();
          }, { once: true });
        }
      });
    },

    lockBodyScroll() {
      document.documentElement.style.scrollBehavior = 'auto';
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + this.savedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
    },

    unlockBodyScroll() {
      var y = this.savedScrollY;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
      window.scrollTo(0, y);
      // Re-enable smooth scrolling after a tick
      requestAnimationFrame(function() {
        document.documentElement.style.scrollBehavior = '';
      });
    },

    bindScrollPreservation() {
      // Observe #rebuy-cart class changes to lock/unlock body scroll
      var observer = new MutationObserver((mutations) => {
        mutations.forEach((m) => {
          if (m.type !== 'attributes' || m.attributeName !== 'class') return;
          var el = m.target;
          if (el.id !== 'rebuy-cart') return;
          if (el.classList.contains('is-visible')) {
            this.savedScrollY = window.scrollY;
            this.lockBodyScroll();
          } else {
            this.unlockBodyScroll();
          }
        });
      });
      // Start observing once #rebuy-cart exists
      var startObserving = () => {
        var cart = document.getElementById('rebuy-cart');
        if (cart) {
          observer.observe(cart, { attributes: true, attributeFilter: ['class'] });
        } else {
          setTimeout(startObserving, 1000);
        }
      };
      startObserving();
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    MobileBurgerMenu.init();
    SearchToggle.init();
    ProductSwiperManager.init();
    AttentiveForm.init();
    MiniCartTrigger.init();
  });
})();